import React from 'react'

interface Props {
  id?: string
  description?: string
  variant?: '' | 'blockquote'
  editMode?: boolean
  className?: string
}

const EditableDescription = (props: Props) => {
  const {
    description = undefined,
    variant = '',
    editMode = false,
    id = undefined,
    className = '',
  } = props

  return !!description || editMode ? (
    typeof description === 'string' ? (
      variant === 'blockquote' ? (
        <blockquote
          className={className}
          dangerouslySetInnerHTML={{ __html: description }}
          id={id}
        />
      ) : (
        <div className={className} dangerouslySetInnerHTML={{ __html: description }} id={id} />
      )
    ) : (
      <div className={className} id={id}>
        {description}
      </div>
    )
  ) : (
    <></>
  )
}

export default EditableDescription
